<template>
    <div class="page">
        <div class="listHead" :style="!isWeixinFlag?'':'padding-top: 0.5rem;'" >
            <!-- <div v-if="!isApp&&!isWeixinFlag" class="titleBox"><img @click="goBack()" src="@/assets/img/icon_left.png"> {{showName+'拍卖征集'}}</div> -->
            <cpn-panel v-if="!isApp" :extinfo="extinfo" :isDetail="true" :showDownloadCloseBtn="false" :showNav="true" :showBtn="false" :wapTitle="showName+'拍卖征集'" />
            <div class="numBox" :style="isApp?'margin-top: 0rem !important;':''">{{month}}</div>
            <van-list v-model="loading" :finished="finished" finished-text="" @load="onLoad">
            <template v-for="(item,i) in companyList">
                <div :key="'collect_List'+i" class="collectCard" @click="jumpDetails(item)">
                    <div class="collectName"><span>{{item.city}}</span></div>
                    <div class="coverBox">
                        <img :src="item.cover" alt="">
                    </div>
    
                    <div class="dateBox">{{item.start_time}}{{item.end_time!=''?'~'+item.end_time:''}}</div>
                    <div class="dateBox" style="margin-top:0; padding-top: 0;">{{item.address}}</div>
                </div>
    
            </template>
        </van-list>
            <div class="noMore" v-if="noMore">
                <span>我是有底线的</span>
            </div>
        </div>
        <DownLoadApp ref="downloadPop"></DownLoadApp>
    </div>
    </template>
    
    <script>
    import {
        getWXConfig
    } from "@/assets/js/weixinShare";
    import {
        isiOS,
        isWeixin
    } from "@/api/auction/isWeixin";
    import cpnPanel from "@/views/preview/component/panel.vue";
    import {
        collectList
    } from "@/api/new";
    import DownLoadApp from '@/components/common/downloadApp'
    export default {
        components: {
            DownLoadApp,
            cpnPanel
        },
        data() {
            return {
                isApp: false,
                collectList: [],
                showRank: 0,
                companyList: [],
                month: '',
                showName:'',
                collectObj: {},
                appLinkShow: true,
                // 通链接数据
                appLink: '/2/8/0',
                loading: false,
                finished: false,
                extinfo:"",
                noMore: false,
                isWeixinFlag: false,
            }
        },
        methods: {
            onLoad() {
                this.getNewsData();
    
            },
            getNewsData() {
                let params = {
                    page: this.page,
                    collect_id: this.$route.query.showRank,
                }
                // this.loading = true;
                collectList(params).then((res) => {
                    if (res.code == 0) {
                        this.month=res.data.start_month;
                        this.showName=res.data.organ_name
                        if (res.data.morePage == 0 && res.data.list.length == 0) {
                            this.loading = false;
                            this.finished = true;
                        } else if (res.data.list.length) {
                            this.companyList = this.collectList.concat(res.data.list);
                            this.loading = false;
                            this.page++;
                            if (res.data.morePage == 0) {
                                this.finished = true;
                                this.noMore = true;
                            }
                        }
                        document.title = res.data.organ_name+"拍卖征集"
                        window.AFedWxShareData = {
                            title:'「'+res.data.organ_name+'」全球征集 - 雅昌拍卖图录APP',
                            imgUrl: res.data.organ_cover || 'https://img14.artimg.net/public/cms-cloud/png/202405/5566b2277dbef2e8a5c88c260108641e.png',
                            desc: '火热进行中',
                            link: res.data.shareMessage.url
                        }
                        getWXConfig(window.AFedWxShareData);
                    }
                });
            },
            jumpDetails(e) {
                let that = this;
                let bridge = window.WebViewJavascriptBridge;
                    if (e.source_type == 2) {
                        if (this.isApp) {
                            // bridge.callHandler('GotoAppNewsDetail', {
                            //         show_type: 1,
                            //         resource_id: newArray[0].new_url_app
                            //     }, function () {})
                            if (this.version >= 6138000) {
                                bridge.callHandler('GotoAppNewsDetail', {
                                    resource_id: e.source_id
                                }, function () {})
                            } else {
                                if (isiOS) {
                                    window.location.href = 'https://m-auction.artron.net/tulu/wap/share/news?id=' + e.source_id
                                } else {
                                    that.$refs.downloadPop.gotoAppDownload('/2/40/1/' + e.source_id, 0)
                                }
                            }
    
                        } else {
    
                            window.location.href = 'https://m-auction.artron.net/tulu/wap/share/news?id=' + e.source_id
    
                            // window.location.href = newArray[0].new_url_app
                        }
    
                    }
                    if (e.source_type == 1) {
                        if (this.isApp) {
                            bridge.callHandler('GotoAppArticleDetail', {
                                    id: e.source_id
                                }, function () {})
    
                        } else {
    
                            window.location.href = 'https://m-auction.artron.net/topics/' + e.source_id
    
                        }
    
                    }
    
            },
            goBack() {
                if (document.referrer) {
                    window.location.href = document.referrer
                } else if (window.history.state) {
                    this.$router.back()
                } else if (this.$route.query.fromlink) {
                    window.location.href = decodeURIComponent(this.$route.query.fromlink)
                } else {
                    this.$router.push({
                        path: "/"
                    });
                }
            },
    
        },
        mounted() {
            this.isApp = (/(SwiftTuLu|ArtronTulu|HarmonyOSTulu)/g).test(window.navigator.userAgent)
            this.extinfo=JSON.stringify({url: "h5",param: window.location.href})
            this.isWeixinFlag=isWeixin()
        }   
    }
    </script>
    
    <style lang="scss">
    body {
        background: #F5F5F5 !important;
    }
    </style>
    <style lang="scss" scoped>
    @import url("../../assets/css/reset.css");
    /deep/ body {
        background: #F5F5F5;
    }
    
    .page {
    
        .listHead {
            width: 100%;
            height: 12rem;
            padding-top: 1rem;
            background: linear-gradient(180deg, #FFFFFF 63%, rgba(255, 255, 255, 0) 97%);
    
            .collectCard {
                width: 90%;
                margin: .5rem 5%;
                background: #FFFFFF;
                box-shadow: 0px 14px 26px -10px rgba(0, 0, 0, 0.1);
                border-radius: 1rem;
                padding-bottom: 0.5rem;
                box-sizing: border-box;
    
                .dateBox {
                    width: 100%;
                    padding: 0.5rem 1rem 0.3rem 1rem;
                    font-size: 0.6rem;
                    font-weight: 400;
                    margin-top: 5px;
                    box-sizing: border-box;
    
                }
    
                .coverBox {
                    width: 100%;
                    padding: 0 0.8rem;
                    position: relative;
                    box-sizing: border-box;
    
                    // &::after {
                    //     content: "";
                    //     position: absolute;
                    //     width: 80%;
                    //     left: 10%;
                    //     bottom: -4px;
                    //     border-radius: 1rem;
                    //     z-index: 2;
                    //     height: 3rem;
                    //     background: rgba(169, 169, 169, 0.5);
                    // }
    
                    // &::before {
                    //     content: "";
                    //     position: absolute;
                    //     width: 76%;
                    //     left: 12%;
                    //     bottom: -8px;
                    //     border-radius: 1rem;
                    //     height: 3rem;
                    //     background: rgba(169, 169, 169, 0.3);
                    // }
    
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                        position: relative;
                        z-index: 3;
                        border-radius: 1rem;
                    }
                }
    
                .collectName {
                    width: 100%;
                    padding: 0.5rem 1rem;
                    box-sizing: border-box;
    
                    img {
                        width: 2rem;
                        height: 2rem;
                        object-fit: contain;
                        margin-right: 0.2rem;
                        border-radius: 2rem;
                        border: 1px solid rgba(0, 0, 0, 0.06);
                        box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.06);
                        vertical-align: middle;
    
                    }
    
                    span {
                        font-size: 0.75rem;
                        font-weight: 600;
                    }
                }
            }
    
            .numBox {
                font-size: 0.6rem;
                font-weight: 400;
                color: #6B6C6C;
                line-height: 2rem;
                padding-left: 1rem;
            }
    
            .titleBox {
                width: 100%;
                height: 2rem;
                z-index: 5;
                background: #FFFFFF;
                font-size: 0.7rem;
                line-height: 2rem;
                font-weight: 600;
                color: #000000;
                position: fixed;
                top: 0;
                left: 0;
                text-align: center;
    
                img {
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 48px;
                    height: 40px;
                }
            }
    
        }
    
    }
    </style>
    